/** Default dimmed backdrop behind the sheet. translateZ(0) promotes it to its own
 *  compositing layer so it dims the WHOLE page — including headers that are themselves
 *  composited (e.g. the reserve header's translateZ(0)), which a plain, higher-z-index
 *  scrim wouldn't cover on iOS. */
export const backdropBaseClasses =
  'tw:fixed tw:inset-0 tw:bg-black/40 tw:transition-opacity animate-backdrop-fade-in tw:[transform:translateZ(0)]';

/** Default backdrop z-index — above the app header (z-50) so the entire page dims. */
export const backdropDefaultZ = 'tw:z-[51]';

/** Sheet container — bottom sheet on mobile, centered popup on desktop.
 *  will-change:transform promotes the sheet to its own compositing layer so it paints
 *  ABOVE the reserve results list (DraggablePanel), which is itself composited
 *  (will-change:transform). Without this, on iOS the composited list paints over the
 *  non-composited sheet regardless of z-index — the sheet's content vanishes behind the
 *  map/list. will-change (not translateZ(0)) so it doesn't override the slide-up keyframe. */
export const sheetBaseClasses = [
  // Shared
  'tw:fixed tw:flex tw:flex-col tw:bg-white tw:shadow-lg tw:will-change-transform',
  // Mobile: bottom sheet
  'tw:bottom-0 tw:left-0 tw:right-0 tw:max-h-[85vh] tw:rounded-t-[var(--radius-16)] animate-bottomsheet-slide-up tw:pb-[var(--spacing-base)]',
  // Desktop (>=480px): centered popup
  'tw:max-[480px]:bottom-0 tw:min-[480px]:bottom-auto tw:min-[480px]:top-1/2 tw:min-[480px]:left-1/2 tw:min-[480px]:-translate-x-1/2 tw:min-[480px]:-translate-y-1/2',
  'tw:min-[480px]:w-[480px] tw:min-[480px]:max-h-[90vh] tw:min-[480px]:rounded-[var(--radius-16)]',
].join(' ');

/** Default sheet z-index — above the backdrop (z-51). */
export const sheetDefaultZ = 'tw:z-[52]';

/** Header row with title and close button. */
export const headerClasses =
  'tw:flex tw:shrink-0 tw:items-center tw:justify-between tw:border-b tw:border-solid tw:border-gray-light tw:px-[var(--spacing-base)] tw:py-[var(--spacing-small)]';

/** Sheet title text. */
export const titleClasses = 'tw:text-16 tw:font-bold tw:text-font';

/** Close button in the header. shrink-0 keeps the fixed-size icon from squeezing the
 *  title so multi-word titles (e.g. "Add New Bank Account") render in full (PB-2911). */
export const closeButtonClasses =
  'tw:flex tw:shrink-0 tw:items-center tw:justify-center tw:rounded tw:p-1 tw:text-gray-dark tw:transition-opacity tw:hover:opacity-80 tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-primary';

/** Scrollable body area. */
export const bodyClasses = 'tw:flex-1 tw:overflow-y-auto ';
